export default {
    tms: {

    },
    generic: {
        Home:"หน้าหลัก",
        ReporMaster: "ผู้ดูแลรายงาน",
        GenericName: "ชื่อทั่วไป",
        ModuleCode: "รหัสโมดูล",
        Description: "คำอธิบาย",
        FunctionCode: "รหัสฟังก์ชัน",
        PageTitleCode: "รหัสหัวข้อหน้า",
        IsPaging: "แบ่งหน้าหรือไม่",
        IgnoreCount: "หน้าก่อนหน้า/หน้าถัดไป",
        Creator: "ผู้สร้าง",
        CreateDate: "วันที่สร้าง",
        Modifier: "ผู้แก้ไข",
        ModifyDate: "วันที่แก้ไข",
        GMCUID: "GMC UID",
        SCHEMAUID: "SCHEMA UID",
        UIAction: "การกระทำ UI",
        Validation: "การตรวจสอบ",
        Editable: "แก้ไขได้",
        Searchable: "ค้นหาได้",
        DefaultValue: "ค่าเริ่มต้น",
        Madatory: "บังคับ",
        Displayable: "แสดงได้",
        Sequence: "ลำดับ",
        Condition: "เงื่อนไข",
        Mandatory: "บังคับ",
        AndOr: "และ/หรือ",
        GCDUID: "GCD UID",
        ParentGCDUID: "GCD UID หลัก",
        IfOrNotMove:"ต้องการการย้ายคลังสินค้าหรือไม่?",
        TableName: "ชื่อตาราง",
        EnglishName: "ชื่อภาษาอังกฤษ",
        CnName: "ชื่อภาษาจีน",
        TraditionalCNName: "ชื่อภาษาจีนดั้งเดิม",
        KorName: "ชื่อภาษาเกาหลี",
        thName: "ภาษาไทย",
        jpName: "ภาษาญี่ปุ่น",
        Header: "ข้อมูลหลัก",
        TableAlias: "นามแฝงตาราง",
        FieldName: "ชื่อฟิลด์",
        FieldType: "ประเภทฟิลด์",
        FieldLength: "ความยาวฟิลด์",
        FieldLengthDecimal: "ความยาวทศนิยมฟิลด์",
        ForeignTable: "ตารางต่างประเทศ",
        ForeignFIELD: "ฟิลด์ต่างประเทศ",
        LanguageCode: "รหัสภาษา",
        Module: "โมดูล",
        SubPage: "หน้าย่อย",
        SubModule: "โมดูลย่อย",
        Function: "ฟังก์ชัน",
        PageTitle: "หัวข้อหน้า",
        Decimal: "ทศนิยม",
        Edit: "แก้ไข",
        Add: "เพิ่ม",
        More: "เพิ่มเติม",
        AreyoudeleTask: "คุณแน่ใจหรือไม่ว่าต้องการลบระเบียนที่เลือก",
        Yes: "ใช่",
        No: "ไม่",
        Delete: "ลบ",
        Zip: "บีบอัด Zip",
        Up: "ขึ้น",
        Down: "ลง",
        Store: "จัดเก็บ",
        ButtonGroupName: "ชื่อกลุ่มปุ่ม",
        Apply: "นำไปใช้",
        Configuration: "การกำหนดค่า",
        Name: "ชื่อ",
        RenderType: "ประเภทการเรนเดอร์",
        Type: "ประเภท",
        Code: "รหัส",
        ViewType: "ประเภทมุมมอง",
        PatternType: "ประเภทรูปแบบ",
        ExtenalAPI: "API ภายนอก",
        MapToModule: "แผนที่ไปยังโมดูล",
        FieldMap: "แผนที่ฟิลด์",
        BehaviorPattern: "รูปแบบพฤติกรรม",
        Parameters: "พารามิเตอร์",
        CustPage: "CustPage",
        Action: "การกระทำ",
        Width: "ความกว้าง",
        ConsParameter: "พารามิเตอร์ Cons.",
        Constrainttable: "ตารางข้อจำกัด",
        Seq: "ลำดับ",
        ValidationSQL: "SQL การตรวจสอบ",
        operate: "ดำเนินการ",
        Group: "กลุ่ม",
        FKTable: "ตาราง FK",
        FKFieldName: "ชื่อฟิลด์ FK",
        SQLParameters: "พารามิเตอร์ SQL",
        defaultValue: "ค่าเริ่มต้น",
        DisplayColumns: "แสดงคอลัมน์",
        SortSeq: "ลำดับการจัดเรียง",
        OrderBy: "เรียงตาม",
        Refresh: "รีเฟรช",
        PagePropertyGroupName: "ชื่อกลุ่มคุณสมบัติหน้า",
        Disaplyable: "แสดงได้",
        Like: "เบลอ",
        IsShowTitle: "แสดงชื่อเรื่องหรือไม่",
        ShowTitleSeq: "แสดงลำดับชื่อเรื่อง",
        OptionType: "ประเภทตัวเลือก",
        ExtentionValue: "ค่าส่วนขยาย",
        GenIdtype: "ประเภท Gen Id",
        Hyperlink: "ไฮเปอร์ลิงก์",
        Isitunique: "ไม่ซ้ำกันหรือไม่",
        Statistics: "สถิติ",
        DataFormat: "รูปแบบข้อมูล",
        FieldPattern: "รูปแบบฟิลด์",
        GenericParameters: "พารามิเตอร์ทั่วไป",
        DefaultSelected: "เลือกเริ่มต้น",
        IsReserveAdmin: "เป็นผู้ดูแลการสำรองหรือไม่",
        TitleInfo: "ข้อมูลชื่อเรื่อง",
        UniqueParameter: "พารามิเตอร์เฉพาะ",
        Depend: "ขึ้นอยู่กับ",
        IsDefType: "เป็นประเภทเริ่มต้นหรือไม่",
        ConfigurationMethod: "วิธีการคำนวณการกำหนดค่า",
        CalcParameters: "พารามิเตอร์การคำนวณ",
        CalcType: "ประเภทการคำนวณ",
        SurfixParameter: "พารามิเตอร์คำต่อท้าย",
        ComputationalEvent: "เหตุการณ์การคำนวณ",
        TriggerFields: "ฟิลด์ทริกเกอร์",
        IsTrigger: "เป็นทริกเกอร์หรือไม่",
        Publish: "เผยแพร่",
        AdvanceSearch: "ค้นหาขั้นสูง",
        SearchTemplate: "เทมเพลตการกรอง",
        IsDefault: "เป็นค่าเริ่มต้นหรือไม่",
        Loadable: "โหลดได้",
        IsExtra: "เป็นพิเศษหรือไม่",
        ExtraParameters: "พารามิเตอร์พิเศษ",
        TemplateName: "ชื่อเทมเพลต",
        CreateTime: "เวลาสร้าง",
        Copy: "คัดลอก",
        CreateGenericData: "สร้างข้อมูลทั่วไปใหม่",
        AppendGenericData: "เพิ่มข้อมูลทั่วไป",
        DeleteGenericData: "ลบข้อมูลทั่วไป",
        PleasemoduleonlyGeneric: "โปรดตรวจสอบให้แน่ใจว่ามีเพียงโมดูลเดียวที่เริ่มต้นข้อมูลทั่วไป",
        DBSchema: "DB Schema",
        PageProperty: "คุณสมบัติหน้า",
        SQL: "SQL",
        ConfigSQL: "กำหนดค่า SQL",
        Behavior: "พฤติกรรม",
        ForOption: "สำหรับตัวเลือก",
        StartupModule: "โมดูลเริ่มต้น",
        UseViewSQL: "ใช้ View SQL",
        ReportView: "มุมมองรายงาน",
        TableViewName: "ชื่อตาราง/มุมมอง",
        FiledName: "ชื่อฟิลด์",
        Basic: "พื้นฐาน",
        AliasName: "ชื่อนามแฝง",
        SubModuleCode: "รหัสโมดูลย่อย",
        SubModuleName: "ชื่อโมดูลย่อย",
        FunctionName: "ชื่อฟังก์ชัน",
        FunctionLevel: "ระดับฟังก์ชัน",
        ParentFunctionCode: "รหัสฟังก์ชันหลัก",
        FunctionSeq: "ลำดับฟังก์ชัน",
        FunctionURL: "URL ฟังก์ชัน",
        LangCode: "รหัสภาษา",
        Menu: "เมนู",
        GenericMenu: "เมนูทั่วไป",
        RelationTable: "ตารางความสัมพันธ์",
        UserMenu: "เมนูผู้ใช้",
        FunctionAPI: "API ฟังก์ชัน",
        Status: "สถานะ",
        NotInactive: "ไม่อนุญาตให้เผยแพร่การกำหนดค่าที่เผยแพร่แล้วหรือไม่ใช้งาน",
        Mapto: "แผนที่ไปยัง",
        Project: "โครงการ",
        Usage: "การใช้งาน",
        Source: "แหล่งที่มา",
        TargetTo: "กล่องเป้าหมาย",
        ExcelType: "ประเภท Excel",
        OnlyAllowLetter: "อนุญาตเฉพาะตัวอักษรเท่านั้น",
        Export: "ส่งออก",
        SourceMap: "แผนที่แหล่งที่มา",
        MapToView: "แผนที่ไปยังมุมมอง",
        TargetMap: "แผนที่เป้าหมาย",
        Excel: "Excel",
        SelectedMatched: "คอลัมน์ที่เลือกต้องตรงกัน",
        DataDuplication: "ข้อมูลซ้ำกัน",
        UnUploadFile: "โปรดอัปโหลดไฟล์!",
        isShowCopy:"คัดลอก",
        copySuccess:"คัดลอกสำเร็จ",
        totalOf:"รวม ",
        Records:"รายการ"
    },
    userlang: {
        Address1: "ที่อยู่ 1",
        Address2: "ที่อยู่ 2",
        Address3: "ที่อยู่ 3",
        Address4: "ที่อยู่ 4",
        Postal: "รหัสไปรษณีย์",
        Street: "ถนน",
        District: "เขต",
        Latitude: "ละติจูด",
        Longitude: "ลองจิจูด",
        Country: "ประเทศ",
        Enable: "เปิดใช้งาน",
        Disable: "ปิดใช้งาน",
        Empower: "ให้อำนาจ",
        Edit: "แก้ไข",
        EditUser: "แก้ไขผู้ใช้",
        UserAccount: "บัญชีผู้ใช้",
        LoginAccount: "บัญชีผู้ใช้",
        DispName:"ชื่อผู้ใช้",
        Email: "อีเมล",
        EmailInfoFrom: "อีเมลที่ป้อนไม่ถูกต้อง!",
        FirstName: "ชื่อ",
        MiddleName: "ชื่อกลาง",
        LastName: "นามสกุล",
        DisplayName: "ชื่อที่แสดง",
        Title: "คำนำหน้า",
        Gender: "เพศ",
        Male: "ชาย",
        Female: "หญิง",
        Company: "บริษัท",
        Department: "แผนก",
        Position: "ตำแหน่ง",
        Telephone: "โทรศัพท์",
        City: "เมือง",
        SelectCity: "โปรดเลือกเมือง",
        TimeZone: "เขตเวลา",
        english:"ภาษาอังกฤษ",
        englishName:"ชื่อภาษาอังกฤษ",
        sumplifiedName:"ชื่อภาษาจีนตัวย่อ",
        traditionalName:"ชื่อภาษาจีนตัวเต็ม",
        koreanName:"ชื่อภาษาเกาหลี",
        japaneseName:"ชื่อภาษาญี่ปุ่น",
        thaiName:"ชื่อภาษาไทย",
        Language: "ภาษา",
        Jtlang: "ภาษาจีนตัวย่อ",
        korlang: "ภาษาเกาหลี",
        thlang: "ภาษาไทย",
        jplang: "日本語",
        ftlang: "ภาษาจีนตัวเต็ม",
        Orgnization: "องค์กร",
        Project: "โครงการ",
        Delete: "ลบ",
        NorecordFound: "ไม่พบข้อมูล",
        Organization: "องค์กร",
        Warehouse: "คลังสินค้า",
        Address: "ที่อยู่",
        Save: "บันทึก",
        AccessRights: "สิทธิ์การเข้าถึง",
        Pleaseselect: "โปรดเลือก",
        Role: "บทบาท",
        PleaseOneleast: "โปรดเลือกอย่างน้อยหนึ่งรายการ",
        SaveSuccessfully: "บันทึกสำเร็จ",
        AddProject: "เพิ่มโครงการ",
        AddWarehouse: "เพิ่มคลังสินค้า",
        defaultOrg:"ตั้งค่าปริยาย",
        defaultProj:"รายการปริยาย",
        domain:"โดเมน",
        useredQr:"ผู้ใช้ QR"
    },
    convertCountResult: {
        title: "ผลลัพธ์การแปลงการนับ",
        filenameStartFrom: "ชื่อไฟล์เริ่มต้นจาก",
        importSuccess: "นำเข้าสำเร็จ",
        pleaseUpload: "กรุณาอัปโหลดไฟล์",
        noFileToDownload: "ไม่มีไฟล์ให้ดาวน์โหลด",
        invalidFilename: "ชื่อไฟล์เริ่มต้นต้องเป็น 2, S หรือ Q",
        invalidFileType: "รองรับเฉพาะไฟล์นามสกุล .xlsx เท่านั้น"
    },
    publicLang: {
        DeleteSuccess: "ลบสำเร็จ",
        HelpMessage: "ช่วยเหลือ",
        PreviousPage: "หน้าก่อนหน้า",
        NextPage: "หน้าถัดไป",
        Page: "หน้า",
        CourierNumberIsNotNull: "หมายเลขพัสดุไม่สามารถว่างเปล่าได้",
        CourierNumber:"หมายเลขพัสดุ",
        InputRequiredValue: "โปรดกรอกข้อมูลที่จำเป็นก่อน!",
        containerIdNotExists: "หมายเลขคอนเทนเนอร์ไม่มีอยู่หรือได้รับสินค้าแล้ว",
        CartonIdNumNotExists: "หมายเลขกล่องไม่มีอยู่หรือได้รับสินค้าแล้ว",
        PleaseOneLeast: "โปรดเลือกอย่างน้อยหนึ่งรายการ",
        AreUpadte: "ต้องการอัปเดตรายการที่เลือกหรือไม่?",
        NotAllowtodeleteCancel: "ไม่อนุญาตให้ลบ/ยกเลิก",
        Notprintfirst: "ไม่อนุญาตให้พิมพ์ โปรดทำการจัดสรรก่อน",
        Notprintpackfirst: "ไม่อนุญาตให้พิมพ์ โปรดสแกนการบรรจุหีบห่อก่อน",
        ProjectandWarehouse: "โครงการและคลังสินค้า",
        AlertMessage: "ข้อความแจ้งเตือน",
        NewTemplateName: "ชื่อเทมเพลตใหม่",
        ProjectTemplate: "เทมเพลตโครงการ",
        StyleSetting: "การตั้งค่าสไตล์",
        NavigationMode: "โหมดการนำทาง",
        LeftLayout: "เค้าโครงเมนูด้านซ้าย",
        TopLayout: "เค้าโครงเมนูด้านบน",
        Arecancel: "ยืนยันการลบหรือไม่?",
        Areconfirm: "ยืนยันการส่งหรือไม่?",
        Yes: "ใช่",
        No: "ไม่",
        SKUSearch: "ค้นหาสินค้า",
        StatusNotNew:"สถานะคำสั่งซื้อต้องไม่ใช่สถานะใหม่",
        PubOk: "ตกลง",
        theIstAdministrator: "ผู้ใช้ปัจจุบันยังไม่ได้รับสิทธิ์ โปรดติดต่อผู้ดูแลระบบ",
        PleaseSltAtleast: "โปรดเลือกอย่างน้อยหนึ่งรายการ",
        ColumnSearchRequired: "โปรดตั้งเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการก่อนโหลดข้อมูล",
        PleaseCheckDisplayableFirst: "กรุณาตรวจสอบสามารถแสดงได้ก่อน!",
        pleaseOneOnly: "โปรดเลือกเพียงหนึ่งรายการเท่านั้น",
        SelectRestrict: "จำนวนข้อมูลที่เลือกต้องไม่เกิน 100 แถว",
        PleaseFirst: "โปรดเลือกหนึ่งรายการ",
        DraglistSort: "ลากรายการเพื่อจัดเรียง",
        CreatTime: "เวลาสร้าง",
        Clear: "ล้าง",
        Save: "บันทึก",
        UpdateSuccess: "อัปเดตสำเร็จ",
        PasswordUpdatedSuccessfully: "อัปเดตรหัสผ่านสำเร็จ!",
        Project: "โครงการ",
        PleaseSelect: "โปรดเลือก",
        Required: "จำเป็น",
        ThenotEmail: "อีเมลที่ป้อนไม่ถูกต้อง",
        PleaseEnter: "โปรดป้อน",
        PleaseMobileNumberCorrectly: "โปรดป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
        RequireNumerFormat: "โปรดป้อนรูปแบบตัวเลข",
        SystemAdministrator: "การกำหนดค่าระบบผิดพลาด โปรดติดต่อผู้ดูแลระบบ",
        Download: "ดาวน์โหลด",
        Preview: "ดูตัวอย่าง",
        Wrongconfiguration: "การกำหนดค่าผิดพลาด",
        NotAllowToOverReceive: "ไม่อนุญาตให้รับเกิน",
        Search: "ค้นหา",
        Close: "ปิด",
        sendEdi: "ส่ง Edi",
        rePrint: "พิมพ์ซ้ำ",
        Cancel: "ยกเลิก",
        Confirm: "ยืนยัน",
        CheckComplete: "ตรวจสอบเสร็จสมบูรณ์",
        CancelCheckComplete: "ยกเลิกการตรวจสอบเสร็จสมบูรณ์",
        Template: "เทมเพลต",
        Loading: "กำลังโหลด",
        notExistScanInList: "{0} ไม่มีอยู่ในรายการสแกนเข้า",
        prompt: "ข้อความแจ้งเตือน", // 提示
        closePrompt:"ยืนยันการปิดคำสั่งซื้อหรือไม่?",
        cancelPrompt: "คุณต้องการยืนยันการยกเลิกคำสั่งซื้อหรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้",
        IncorrectConfiguration: "การกำหนดค่าไม่ถูกต้อง",
        NoreportFound: "ไม่พบรายงาน",
        PleaseinputEmail: "โปรดป้อนอีเมล!",
        Upload: "อัปโหลด",
        UploadPhoto: "อัปโหลดรูปภาพ",
        UploadSuccess: "อัปโหลดสำเร็จ!",
        DownloadCenter: "ศูนย์ดาวน์โหลด",
        FileName: "ชื่อไฟล์",
        Action: "ฟังก์ชัน",
        overScanMsg:"{0} ไม่อนุญาตให้สแกนเกิน",
        overRemoveMsg:"{0} ไม่อนุญาตให้ลบเกิน",
        locationIsNull:"ตำแหน่งไม่สามารถว่างเปล่าได้",
        ConfirmShipment: "ยืนยันการจัดส่งหรือไม่?",
        LastSKUCheckCompletePrompt:"การบรรจุหีบห่อคำสั่งซื้อเสร็จสมบูรณ์ โปรดตรวจสอบ",
        statusError:"{0} สถานะผิดพลาด",
        waveIdIsNotEmpty:"{0} คำสั่งซื้อมีหมายเลขคลื่นอยู่แล้ว",
        UploadFileOverSize:"ไฟล์ที่อัปโหลดมีขนาดเกินขีดจำกัด โปรดตรวจสอบ",
        UploadFailed: "อัปโหลดล้มเหลว",
        DownloadFailed: "ดาวน์โหลดล้มเหลว",
        cardNeedReplace:"ต้องเปลี่ยนการ์ด",
        NoPickedStockInContainer:"คอนเทนเนอร์นี้ไม่มีสินค้าที่หยิบ!",
        needToHangGooseDownGoldMedal:"ต้องแขวนเหรียญทองขนห่าน"
    },
    roleGe: {
        RoleLevel: "ระดับบทบาท",
        ModuleName: "ชื่อโมดูล",
        SubModuleName: "ชื่อโมดูลย่อย",
        Add: "เพิ่ม",
        Delete: "ลบ",
        Edit: "แก้ไข",
        EditRole: "แก้ไขบทบาท",
        CreateRole: "สร้างบทบาท",
        RoleName: "ชื่อบทบาท",
        RoleType: "ประเภทบทบาท",
        PleaseSelect: "โปรดเลือก",
        Description: "คำอธิบาย",
        Save: "บันทึก",
        pleaseOneOnly: "โปรดเลือกเพียงหนึ่งรายการ",
        SaveuSccessfully: "บันทึกสำเร็จ",
        RuleType: "ประเภทกฎ",
        RuleName: "ชื่อกฎ",
        Organization: "องค์กร",
        Project: "โครงการ",
        Search: "ค้นหา",
        Creator: "ผู้สร้าง",
        CreateTime: "เวลาสร้าง",
        Modifier: "ผู้แก้ไข",
        ModifiyTime: "เวลาแก้ไข",
        Next: "ถัดไป",
        SortSubmit: "ส่งตามลำดับ",
        Inventory: "สินค้าคงคลัง",
        TableName: "ชื่อตาราง",
        FieldName: "ชื่อฟิลด์",
        InventoryFieldName: "ชื่อฟิลด์สินค้าคงคลัง",
        FieldType: "ประเภทฟิลด์",
        Condition: "เงื่อนไข",
        CustomizeValue: "ค่าที่กำหนดเอง",
        OrderBy: "เรียงตาม",
        Operation: "การดำเนินการ",
        SO: "คำสั่งซื้อ",
        Rule: "กฎ",
        Grouping: "การจัดกลุ่ม",
        GroupingAndOrderBy: "การจัดกลุ่มและเรียงตาม",
        ReportSetting: "การตั้งค่ารายงาน",
        Import: "นำเข้า",
        Lookup: "ค้นหา",
        ReportName: "ชื่อรายงาน",
        ConfigEnableUser: "กำหนดค่าผู้ใช้ที่ใช้งานได้"
    },
    menu: {
        NotificationList: "รายการการแจ้งเตือน",
        Read: "อ่านแล้ว",
        Unread: "ยังไม่ได้อ่าน",
        ViewMore: "ดูเพิ่มเติม",
        YouhaveViewedNotifications: "คุณได้ดูรายการการแจ้งเตือนทั้งหมดแล้ว",
        Receiver: "ผู้รับ",
        ReadTime: "เวลาที่อ่านได้",
        Status: "สถานะ",
        Subject: "หัวข้อ",
        RefType: "ประเภทอ้างอิง",
        RefNum: "หมายเลขอ้างอิง",
        StartTime: "เวลาเริ่มต้น",
        CompleteTime: "เวลาเสร็จสิ้น",
        FirstName: "ชื่อ",
        LastName: "นามสกุล",
        DisplayName: "ชื่อที่แสดง",
        MiddleName: "ชื่อกลาง",
        Email: "อีเมล",
        Title: "คำนำหน้า",
        Gender: "เพศ",
        Male: "ชาย",
        Female: "หญิง",
        Department: "แผนก",
        Position: "ตำแหน่ง",
        Telephone: "โทรศัพท์",
        City: "เมือง",
        TimeZone: "เขตเวลา",
        DefaultLanguage: "ภาษาเริ่มต้น",
        PerformanceFeedback: "ข้อเสนอแนะด้านประสิทธิภาพ",
        SimulateUser: "จำลองผู้ใช้",
        ReleaseUser: "เผยแพร่ผู้ใช้",
        PrintNode: "โหนดการพิมพ์",
        Logout: "ออกจากระบบ",
        NoRecordfound:"ไม่พบข้อมูล"
    },
    easyCron: {
        Specify: "ระบุ",
        NoSet: "ไม่ได้ตั้งค่า",
        OnlyDaysWeeksSet: "สามารถตั้งค่าได้เพียงหนึ่งวันและหนึ่งสัปดาห์เท่านั้น",
        Perday: "ทุกวัน",
        Between: "ระหว่าง",
        Day: "วัน",
        to: "ถึง",
        PreHour: "ทุกชั่วโมง",
        Hour: "ชั่วโมง",
        From: "จาก",
        PerMinute: "ทุกนาที",
        Minute: "นาที",
        PerYear: "ทุกปี",
        Year: "ปี",
        Start: "เริ่มต้น",
        Expire: "หมดอายุ",
        dayWeekNoset: "โปรดระบุวันหรือสัปดาห์",
    },
    pubGicSet: {
        EachGroupRow: "จำนวนแถวต่อใบสั่ง",
        SplitRec: "แยกใบรับสินค้า",
        SelectSKU: "เลือก SKU",
        SelectOneSKU:"โปรดเลือก SKU หนึ่งรายการ",
        QuantityTypeError: "ประเภทปริมาณที่สแกนผิดพลาด",
        soQty: "ปริมาณคำสั่งซื้อ",
        OrderType: "ประเภทคำสั่งซื้อ",
        SelectFieldName: "เลือกชื่อฟิลด์",
        SkuDesc: "รายละเอียดสินค้า",
        WarehouseCode: "รหัสคลังสินค้า",
        NoRecordfound: "ไม่พบข้อมูล!",
        DragTheListTosort: "ลากรายการเพื่อจัดเรียง",
        AdvanceSearch: "ค้นหาขั้นสูง",
        AdvanceSort: "จัดเรียงขั้นสูง",
        FreezeCol: "ตรึงคอลัมน์",
        Clear: "ล้าง",
        Sort: "จัดเรียง",
        Search: "ค้นหา",
        FieldName: "ชื่อฟิลด์",
        OrderBy: "เรียงตาม",
        Name: "ชื่อ",
        PleaseName: "โปรดป้อนชื่อ",
        SearchTemplate: "กรองเทมเพลต",
        AdvanceSearcheTemplate: "เทมเพลตการค้นหาขั้นสูง",
        AreyoudeleTask: "คุณแน่ใจหรือไม่ว่าต้องการลบรายการที่เลือก?",
        UserResetChanges: "การดำเนินการต่อไปนี้จะล้างสิทธิ์ที่ผู้ใช้รายนี้แก้ไข โปรดยืนยันว่าคุณต้องการดำเนินการต่อหรือไม่?",
        ResetPasswordsConfirm: "รหัสผ่านจะถูกรีเซ็ตเป็น NULL โปรดยืนยันว่าต้องการดำเนินการต่อหรือไม่",
        ResetPasswordsButton: "รีเซ็ตรหัสผ่าน",
        InvalidSKU: "SKU {0} ไม่ถูกต้อง",
        CartonClose:"{0} ปิดกล่องแล้ว",
        UnpackedErrorWithEmptyCarton: "{0} กล่องเปล่าไม่สามารถยกเลิกการบรรจุได้อีก",
        NotAllowOverPack: "{0} ไม่อนุญาตให้บรรจุเกิน",
        ScanPackDecodeError:"รูปแบบบาร์โค้ดที่สแกนผิดพลาด",
        NotEnoughSkuRemoved: "กล่องไม่มีปริมาณ {0} เพียงพอ",
        Yes: "ใช่",
        No: "ไม่",
        delete: "ลบ",
        PleaseTamplateNameFirst: "โปรดเลือกชื่อเทมเพลตก่อน",
        SaveSuccess: "บันทึกสำเร็จ",
        Mandatory: "จำเป็น",
        Pleaseselect: "โปรดเลือก",
        SelectPicture: "โปรดเลือกรูปภาพ",
        Split: "แยก",
        FromValue: "จากค่า",
        ToValue: "ถึงค่า",
        NotAllowToSplit: "ไม่อนุญาตให้แยกคำสั่งซื้อ",
        PleaseSelectFieldName: "โปรดเลือกชื่อฟิลด์",
        FieldAddedRepeatedly: "ชื่อฟิลด์ไม่สามารถเพิ่มซ้ำได้",
        ToLocationRequired: "ตำแหน่งปลายทางจำเป็น",
        QtyRequired: "ปริมาณจำเป็น",
        qtyTolocatioRequired: "ปริมาณตำแหน่งปลายทางจำเป็น",
        PleaseCheckTheData: "โปรดตรวจสอบข้อมูล",
        ToValueCannotBeEmpty:"ค่าถึงไม่สามารถว่างเปล่าได้",
        RecQty: "ปริมาณที่รับ",
        Location: "ตำแหน่ง",
        ToLocation: "ตำแหน่งปลายทาง",
        LocationISrequired: "ตำแหน่งจำเป็น",
        NewContainer: "คอนเทนเนอร์ใหม่",
        LoadedCartonQty: "ปริมาณกล่องที่โหลดแล้ว",
        ContainerNo: "หมายเลขคอนเทนเนอร์",
        SSCC: "หมายเลขกล่อง/หมายเลขพัสดุ",
        trackingNo: "หมายเลขพัสดุ",
        SSCC1: "หมายเลขกล่อง",
        lockUpSSCC: "ล็อคหมายเลขกล่อง",
        AmrContainerNo:"หมายเลขคอนเทนเนอร์ AMR",
        iWmsContainerNo:"หมายเลขคอนเทนเนอร์ iWMS",
        HiddenTable: "ซ่อนตาราง",
        logisticsid: "หมายเลขพัสดุ",
        RemoveCartonFromContainer: "นำกล่องออกจากคอนเทนเนอร์",
        RelID: "หมายเลขคำสั่งซื้อ",
        PackID: "รหัสบรรจุภัณฑ์",
        Carton: "กล่อง#",
        SKUQty: "ปริมาณสินค้า",
        NewPallet: "พาเลทใหม่",
        PalletNo: "หมายเลขพาเลท",
        WeightPallet:"น้ำหนักพาเลท",
        Length: "ยาว",
        InputaNumber: "โปรดป้อนตัวเลข",
        Width: "กว้าง",
        Height: "สูง",
        CBM: "ปริมาตร",
        Weight: "น้ำหนัก",
        WeightUOM: "หน่วยน้ำหนัก",
        LoadedPalletQty: "ปริมาณพาเลทที่โหลดแล้ว",
        RemovePalletfromContainer: "โปรดนำพาเลทออกจากคอนเทนเนอร์",
        Remarks: "หมายเหตุ",
        Desc:"รายละเอียด",
        SKU: "สินค้า",
        LogicalWH: "คลังสินค้าเชิงตรรกะ",
        LotID: "รหัสล็อต",
        AvailableQty: "ปริมาณที่ใช้ได้",
        AdjustQty: "ปรับปริมาณ",
        ReasonCode: "รหัสเหตุผล",
        Action: "เพิ่มหรือลด",
        Adjust: "ปรับ",
        NotEnoughInventoryToAdjust:"ไม่มีสินค้าคงคลังเพียงพอที่จะปรับ",
        ActionCannotBeEmpty: "เพิ่มหรือลดไม่สามารถว่างเปล่าได้",
        ToLocationCannotBeEmpty: "ตำแหน่งปลายทางไม่สามารถว่างเปล่าได้",
        ToSkuCannotBeEmpty: "สินค้าปลายทางไม่สามารถว่างเปล่าได้",
        NotEnoughInventoryToMove : "ไม่มีสินค้าคงคลังเพียงพอที่จะย้าย",
        DataNotChange: "ข้อมูลไม่เปลี่ยนแปลง ไม่จำเป็นต้องบันทึก",
        DataModifyNotSave: "ข้อมูลที่แก้ไขยังไม่ได้บันทึก",
        BatchUpdateShipment: "อัปเดตการจัดส่งเป็นชุด",
        BathUpdate: "อัปเดตเป็นชุด",
        BatchUpdate: "อัปเดตเป็นชุด",
        ButtonConfig: "การกำหนดค่าปุ่ม",
        ButtonConfigName: "ชื่อการกำหนดค่าปุ่ม",
        BePrint: "พิมพ์",
        ActionValue: "ค่าการดำเนินการ",
        DeAllocation: "ยกเลิกการจัดสรร",
        BatchNo: "หมายเลขชุดการผลิต",
        Qty: "ปริมาณ",
        originalLotId: "รหัสล็อตต้นฉบับ",
        soLineSeq: "ลำดับบรรทัดคำสั่งซื้อ",
        PickLineSeq: "ลำดับบรรทัดการหยิบ",
        ModifyTime: "เวลาแก้ไข",
        ShipOutDate: "วันที่จัดส่ง",
        GenerateLocation: "สร้างตำแหน่ง",
        RowName: "ชื่อแถว",
        ColumnInRow: "คอลัมน์ในแถว",
        LevelInRow: "ระดับในแถว",
        BinsinLocation: "ช่องในตำแหน่ง",
        CartonToContainer: "กล่องไปยังคอนเทนเนอร์",
        CartonToPallet: "กล่องไปยังพาเลท",
        PalletToContainer: "พาเลทไปยังคอนเทนเนอร์",
        Error: "ข้อผิดพลาด",
        Lookup: "ค้นหา",
        PrePrintLPN: "พิมพ์ LPN ล่วงหน้า",
        NumberOfLPNLabelRequired: "หมายเลขฉลาก LPN จำเป็น",
        Print: "พิมพ์",
        ReprintLPN: "พิมพ์ LPN ซ้ำ",
        Lpn:"LPN",
        Reprint: "พิมพ์ซ้ำ",
        LastPrinted: "พิมพ์ล่าสุด",
        MoveLogic: "ตรรกะการย้ายสินค้า",
        Reason:"เหตุผล",
        FromLocation: "ตำแหน่งต้นฉบับ",
        MoveQty: "ปริมาณที่ย้าย",
        ColumnName: "ชื่อคอลัมน์",
        printReportColumn: "ชื่อคอลัมน์รายงานการพิมพ์",
        ScanIn: "สแกนเข้า",
        RecID: "หมายเลขคำสั่งซื้อ",
        CartonID:"รหัสกล่อง",
        TraceID:"รหัสติดตาม",
        ContainerId:"คอนเทนเนอร์",
        CartonIdNum: "หมายเลขกล่อง",
        DeleteCartonID:"ลบรหัสกล่อง",
        CartonIdQty:"ปริมาณรหัสกล่อง",
        CartonIdNumRegExp:"ข้อผิดพลาดนิพจน์ทั่วไปของหมายเลขกล่อง",
        CartonIdNumFormatError:"ข้อผิดพลาดหมายเลขกล่อง# {0} โปรดสแกนใหม่",
        ContainerIdIsEmpty:"คอนเทนเนอร์จำเป็น",
        EPC:"รหัสป้องกันการปลอมแปลง",
        EPCIsEmpty:"รหัสป้องกันการปลอมแปลงจำเป็น",
        EPCFormatError:"รหัสป้องกันการปลอมผิดปกติ, กรุณาระบุอีกครั้ง.",
        EpcQtyMustBeOne:"รหัสป้องกันการปลอมแปลงสามารถสแกนได้ทีละชิ้นเท่านั้น",
        SSCCIsEmpty:"หมายเลขกล่องจำเป็น",
        cartonTypeIsEmpty:"ประเภทกล่องจำเป็น",
        ConvertToReceive:"แปลงเป็นรับ",
        CancelGR: "ยกเลิก GR",
        NewGR: "GR ใหม่",
        Descr: "รายละเอียด",
        ASNQty: "ปริมาณที่คาดว่าจะได้รับ",
        OutstandingQty: "ปริมาณที่ยังไม่ได้สแกน",
        ContainerIdQty: "ปริมาณคอนเทนเนอร์",
        ScanAction: "เหตุการณ์การสแกน",
        RemoveSku:"ลบ",
        addSku:"เพิ่ม",
        StockStatus: "สถานะสต็อก",
        LockScanQty: "ล็อคปริมาณที่สแกน",
        LockContainer: "ลบรหัสกล่อง",
        NoofSKU: "ประเภทสินค้า",
        NoofCartonID: "หมายเลขกล่อง",
        UOM: "หน่วยวัด",
        ScanPack: "สแกนบรรจุภัณฑ์",
        WaveID: "รหัสคลื่น",
        CancelPack: "ยกเลิกการบรรจุภัณฑ์",
        PrintPackingList: "พิมพ์ใบจัดสินค้า",
        PackingList: "พิมพ์ใบรายการบรรจุภัณฑ์",
        AllocatedQty: "ปริมาณที่จัดสรร",
        PackedQty: "ปริมาณที่บรรจุแล้ว",
        PackedQty2: "ปริมาณที่บรรจุแล้ว",
        RemoveScanItem: "ลบรายการที่สแกน",
        IsCarton: "สแกนกล่อง",
        ScanInDirectly:"สแกนโดยตรง",
        IsPrePack: "บรรจุล่วงหน้าหรือไม่",
        IsTraceId: "เป็นรหัสติดตามหรือไม่",
        UnpackQty: "ปริมาณที่ยังไม่ได้บรรจุ",
        Detail: "รายละเอียด",
        Percentage: "เปอร์เซ็นต์",
        NoofCarton: "หมายเลขกล่อง",
        Createdby: "สร้างโดย",
        CloseAndNew: "ปิดและสร้างใหม่",
        New: "สร้างใหม่",
        Remove: "ลบ",
        Append: "ผนวก",
        ImportScanningFile: "นำเข้าไฟล์สแกน",
        ImportSacnningFileGroupName: "นำเข้าไฟล์สแกน",
        PrintSSCC: "พิมพ์ฉลากกล่อง",
        PrintCarton: "พิมพ์ฉลากกล่อง",
        CartonNoSSCC: "หมายเลขกล่อง/SSCC",
        ScannedQty: "ปริมาณที่สแกน",
        CartonNo: "หมายเลขกล่อง",
        CartonType: "ประเภทกล่อง",
        DimUOM: "หน่วยวัดขนาด",
        GrossWeight: "น้ำหนักรวม",
        NetWeight: "น้ำหนักสุทธิ",
        PleaseNewOneCartonFirst: "โปรดสร้างกล่องใหม่ก่อน",
        Nosscc: "ไม่มี SSCC โปรดป้อน SSCC ที่จำเป็นสำหรับการสแกน",
        CancelTransit: "ยกเลิกการขนส่ง",
        Transit: "การขนส่ง",
        Step: "ขั้นตอน",
        FromQty: "ปริมาณต้นฉบับ",
        ToQty: "ปริมาณปลายทาง",
        ToSku: "สินค้าปลายทาง",
        FromSku: "สินค้าต้นฉบับ",
        CourierEdi: "EDI ผู้จัดส่ง",
        IntersoftGenerateLabel: "Intersoft สร้างฉลาก",
        IntersoftCancelLabel: "Intersoft ยกเลิกฉลาก",
        IntersoftGenerateMainfest: "Intersoft สร้างรายการ",
        exportPackageData: "ส่งออกข้อมูลบรรจุภัณฑ์",
        orderCheckCompleteStartTime: "เวลาเริ่มต้นการตรวจสอบคำสั่งซื้อ",
        orderCheckCompleteEndTime: "เวลาสิ้นสุดการตรวจสอบคำสั่งซื้อ",
        whetherToPrintOnlyCompletedOrders: "พิมพ์เฉพาะคำสั่งซื้อที่ตรวจสอบแล้วเท่านั้นหรือไม่",
        addSoToWave:"เชื่อมโยงคำสั่งซื้อกับคลื่น",
        waveId:"รหัสคลื่น",
        ref01:"รหัสอ้างอิง 01",
        ref02:"รหัสอ้างอิง 02",
        ref03:"รหัสอ้างอิง 03",
        ref04:"รหัสอ้างอิง 04",
        ref05:"รหัสอ้างอิง 05",
        query:"สอบถาม",
        reset:"รีเซ็ต",
        save:"บันทึก",
        gift:"ของขวัญ",
        notGiftScanAntiCode:"ไม่ใช่ของขวัญ ต้องสแกนรหัสป้องกันการปลอมแปลง",
        searchCartonByWave:"ค้นหากล่องตามคลื่น",
        importSscc:"นำเข้า SSCC",
        pleaseScanAntiCode:"โปรดสแกนรหัสป้องกันการปลอมแปลง"
    },
    manual: {
        Manual: "ด้วยตนเอง",
        New: "สร้างใหม่",
        AddToPick: "เพิ่มไปยังการหยิบ",
        Unpick: "ยกเลิกการหยิบ",
        SO: "หมายเลขคำสั่งซื้อ",
        Sku: "สินค้า",
        RecID: "หมายเลขคำสั่งซื้อ",
        BatchNo: "หมายเลขชุด",
        SODate: "วันที่สั่งซื้อ",
        AllQty: "ปริมาณที่จัดสรร/ปริมาณการสั่งซื้อ",
        AllocateLocation: "จัดสรรตำแหน่ง",
        Status: "สถานะ",
        LotID: "รหัสล็อต",
        RecDate: "วันที่รับสินค้า",
        RecQty: "ปริมาณที่รับ",
        AvailableQty: "ปริมาณที่ใช้ได้",
        AllocateQty: "ปริมาณที่จัดสรร",
        ShippedQty: "ปริมาณที่จัดส่งแล้ว",
        MANUFACTUREDate: "วันที่ผลิต",
        EXPIRYDate: "วันหมดอายุ",
        SHELFDate: "วันที่วางบนชั้นวาง",
        NewpickPleasego: "สร้างใบหยิบสินค้าใหม่และดำเนินการต่อ"
    },
    login: {
        SignAccount: "เข้าสู่ระบบด้วยบัญชีที่คุณมีอยู่",
        loginTitle1: "ยินดีต้อนรับกลับมา",
        loginTitle2: "โปรดเข้าสู่ระบบบัญชีของคุณ",
        loginTitle3: "การยืนยันสองขั้นตอน",
        loginTitle4: "ขั้นตอนเพิ่มเติมนี้พิสูจน์ว่าบัญชีที่เข้าสู่ระบบปัจจุบันเป็นของคุณจริงๆ",
        loginTitle5:"รับรหัสยืนยันผ่านหมายเลขโทรศัพท์ต่อไปนี้: **** **",
        loginTitle6:"",
        loginTitle7:"ต้องชำระ",
        loginTitle8:"ค่าธรรมเนียมการสื่อสารทั่วไป",
        loginTitle9:"รับรหัสยืนยันทางอีเมล",
        loginTitle10:"รหัสยืนยัน",
        loginTitle11:"โปรดป้อนรหัสยืนยัน",
        loginTitle12:"เชื่อถือเบราว์เซอร์นี้หรือไม่?",
        loginTitle13:"คุณยังคงต้องใช้รหัสผ่านเพื่อเข้าสู่เว็บไซต์ แต่ครั้งต่อไปที่คุณเข้าสู่ระบบ คุณจะไม่ถูกขอให้ป้อนรหัสยืนยันอีก (ในอนาคต",
        loginTitle27:"วัน)",
        loginTitle14:"รับรหัสยืนยันผ่านแอปพลิเคชันเช่น Google หรือ Microsoft Authenticator",
        loginTitle15:"และอื่นๆ",
        loginTitle16:"ตั้งค่า",
        loginTitle17:"ยกเลิกการตั้งค่า",
        loginTitle18:"ติดตั้ง TOTP ที่คุณเลือก",
        loginTitle19:"(รหัสผ่านแบบใช้ครั้งเดียวตามเวลา) Authenticator",
        loginTitle20:"สแกน QR Code",
        loginTitle21:"หรือ",
        loginTitle22:"ป้อน 'รหัสลับ' ลงในแอปพลิเคชัน Authenticator ของคุณ",
        loginTitle23:"ตั้งค่าเสร็จสมบูรณ์",
        loginTitle24:"ตั้งค่าเสร็จสมบูรณ์",
        loginTitle25:"รหัสลับ",
        loginTitle26:"รหัสลับผิดพลาด",
        Verify: "ยืนยัน",
        PleaseUsername: "โปรดป้อนชื่อผู้ใช้!",
        Username: "ชื่อผู้ใช้", // user name
        Password: "รหัสผ่าน",
        language: "ภาษา",
        PleasePassword: "โปรดป้อนรหัสผ่าน!",
        ForgotPassword: "ลืมรหัสผ่าน",
        KeepIn: "เข้าสู่ระบบค้างไว้",
        SignIn: "เข้าสู่ระบบ",
        Or: "หรือ",
        RegisterNewAccount: "ลงทะเบียนบัญชีใหม่",
        NeedHelpContactAdmin: "ต้องการความช่วยเหลือ? ติดต่อผู้ดูแลระบบของคุณ",
        DonHaveAccount: "ยังไม่มีบัญชี?",
        SignUPnow: "ลงทะเบียน",
        UserPasswordError: "ชื่อผู้ใช้หรือรหัสผ่านผิดพลาด",
        Cancel: "ยกเลิก",
        Create: "สร้าง",
        EmailAddress: "ที่อยู่อีเมล",
        VerificationCode: "รหัสยืนยัน",
        Pleaseverification: "โปรดป้อนรหัสยืนยัน",
        Sendverification: "ส่งรหัสยืนยัน",
        NewPassword: "รหัสผ่านใหม่",
        passWordError1: "ความยาวรหัสผ่าน 8 ~ 64 ตัวอักษร",
        passWordError2: "",
        passWordError3: "- ตัวอักษรพิมพ์เล็กหนึ่งตัว",
        passWordError4: "- ตัวอักษรพิมพ์ใหญ่หนึ่งตัว",
        passWordError5: "- ตัวเลขหนึ่งตัว",
        passWordError6: "- สัญลักษณ์หนึ่งตัว",
        ConfirmNewPassword: "ยืนยันรหัสผ่านใหม่",
        PleaseConfirmPassword: "ยืนยันรหัสผ่าน",
        TwopasswordsInconsistent: "รหัสผ่านที่ป้อนไม่ตรงกัน!",
        RegistrationSuccess: "ลงทะเบียนสำเร็จ", // 注册成功
        VerificationAddress: "โปรดคลิกส่งรหัสยืนยัน",
        Submit: "ส่ง",
        NoUserExists: "ไม่มีผู้ใช้",
        CaptchaError: "รหัสยืนยันผิดพลาด",
        CaptchaVerified: "ยืนยันสำเร็จ",
        emailError:"ที่อยู่อีเมลไม่ถูกต้อง",
        authenticationFailure:"การยืนยันตัวตนล้มเหลว",
        SsoAccountMismatch:"บัญชี Microsoft ไม่ตรงกับบัญชีที่ป้อน กรุณาลองใหม่อีกครั้ง",
        OldPassword: "รหัสผ่านเก่า",
        NewpasswordNotoldPassword: "รหัสผ่านใหม่ต้องไม่เหมือนรหัสผ่านเก่า",
        OriginalPasswordError: "รหัสผ่านเก่าผิดพลาด!",
        ResetPassword: "แก้ไขรหัสผ่าน",
        firstLoginChangePassword: "เข้าสู่ระบบครั้งแรกโปรดเปลี่ยนรหัสผ่าน",
        registerForm: "แบบฟอร์มลงทะเบียน",
        UserAlreadyExist: "ผู้ใช้มีอยู่แล้ว!",
        ResetAliasName: "แก้ไขชื่อแทน",
        ChangeAliasName: "แก้ไขชื่อแทน",
        dashboardPortal:"แดชบอร์ด โปรตาล",
        signOut:"ออกจากระบบ",
        view:"ดู",
        previous:"ก่อนหน้า",
        noReportIsSetupForThisAccount:"ไม่มีการตั้งค่ารายงานสำหรับบัญชีนี้",
        PasswordExpiryWarning: "คำเตือนรหัสผ่านหมดอายุ",
        PasswordExpiryMessage: "รหัสผ่านของคุณกำลังจะหมดอายุ",
        PasswordExpiredToday: "รหัสผ่านหมดอายุวันนี้",
        PasswordExpiryDaysLeft: "รหัสผ่านจะหมดอายุใน {days} วัน",
        PleaseChangePasswordImmediately: "กรุณาเปลี่ยนรหัสผ่านทันที"

    },
    batchReceive: {
        BatchReceive: "รับสินค้าเป็นชุด",
        Query: "สอบถาม",
        Accept: "รับ",
        All: "ทั้งหมด",
        Received: "รับสินค้าแล้ว",
        NotReceive: "ยังไม่ได้รับสินค้า",
        ReceiveLocation: "ตำแหน่งรับสินค้า",
        EnterWordsQuery: "ป้อนตัวอักษรมากกว่า 4 ตัวเพื่อสอบถาม",
        EXPQty: "ปริมาณที่คาดหวัง",
        RCVQty: "ปริมาณที่ได้รับ",
        RCVQtyEA: "ปริมาณที่ได้รับ EA",
        TOID: "รหัส TO",
        RCVLOC: "ตำแหน่งรับสินค้า",
        EXPIRYDATE: "วันหมดอายุ",
        Descr: "รายละเอียด",
        SKU: "สินค้า",
        UDF1: "UDF1",
        UDF2: "UDF2",
        UDF3: "UDF3",
        ReceiveRequired: "ตำแหน่งรับสินค้าจำเป็น",
        RCVQtyCheck: "ปริมาณที่ได้รับต้องมากกว่า 0",
        RCVQtyGtExpQty: "ปริมาณที่ได้รับต้องไม่มากกว่าปริมาณที่คาดหวัง",
        Status: "สถานะ",
        Line: "หมายเลขบรรทัด",
        RecDate: "วันที่รับสินค้า",
        LocationCode: "รหัสตำแหน่ง",
        RecQty: "ปริมาณที่รับ",
        RecBaseQty: "ปริมาณที่รับ",
        DamageQty: "ปริมาณที่เสียหาย",
        DamageBaseQty: "ปริมาณที่เสียหาย",
        HoldQty: "ปริมาณที่ระงับ",
        HoldBaseQty: "ปริมาณที่ระงับ",
        Remarks: "หมายเหตุ",
        Desc:"รายละเอียด",
        ProductType: "ประเภทสินค้า",
        ASNQty: "ปริมาณ ASN",
        ASNBaseQty: "ปริมาณ ASN",
        UOM: "หน่วย",
        PackageQty: "ปริมาณบรรจุภัณฑ์",
        ManufactureDate: "วันที่ผลิต",
        ExpiryDate: "วันหมดอายุ",
        ShelfDate: "วันที่วางบนชั้นวาง",
        PalletID: "รหัสพาเลท",
        CartonID: "รหัสกล่อง",
        TraceID:"รหัสติดตาม",
        Article: "บทความ",
        NotAllowToOverReceive: "ไม่อนุญาตให้รับเกิน"
    },


    reportSetting: {
        DevName: "ชื่อผู้พัฒนา",
        ReSQL: "สร้าง SQL ใหม่",
        ColumnDetail: "รายละเอียดคอลัมน์",
        ReportType: "ประเภทรายงาน",
        ReportVersion: "เวอร์ชันรายงาน",
        EnglishName: "ชื่อภาษาอังกฤษ",
        SimplifiedCNName: "ชื่อภาษาจีนตัวย่อ",
        TraditionalCNName: "ชื่อภาษาจีนตัวเต็ม",
        EnglishTipsName: "ชื่อคำแนะนำภาษาอังกฤษ",
        SimplifiedCNTipsName: "ชื่อคำแนะนำภาษาจีนตัวย่อ",
        TraditionalCNTipsName: "ชื่อคำแนะนำภาษาจีนตัวเต็ม",
        DisplaySeq: "ลำดับการแสดงผล",
        CalculateType: "ประเภทการคำนวณ",
        CustCode: "รหัสลูกค้า",
        CustName: "ชื่อลูกค้า",
        ProjectCode: "รหัสโครงการ",
        ProjectName: "ชื่อโครงการ",
        Beautify: "จัดรูปแบบ",
        Verify: "ตรวจสอบ",
        Generate: "สร้าง",
        Version: "เวอร์ชัน",
        Assign: "กำหนด",
        AssignName: "ผู้กำหนด",
        CopyFromMaster: "คัดลอกจาก Master",
        plInpuSku: "โปรดป้อน SKU",
        BatchSave: "บันทึกเป็นชุด",
        SelectAllforSearchable: "เลือกทั้งหมดสำหรับค้นหา",
        SelectAllforDisaplyable: "เลือกทั้งหมดสำหรับแสดงผล",
        importTemplate: "นำเข้าเทมเพลต",
        Upload: "อัปโหลด",
        Clone: "โคลน",
        importConfig: "การกำหนดค่า",
        importColumn: "ฟิลด์หัวข้อ",
        Mapping: "ฟิลด์การแมป",
        Uniquekey: "เป็นค่าเฉพาะหรือไม่",
        DefaultType: "ประเภทเริ่มต้น",
        DataType: "ประเภทข้อมูล",
        Datalength: "ความยาวข้อมูล",
        DecimalalPlace: "ตำแหน่งทศนิยม",
        DateTimeFormat: "รูปแบบวันที่เวลา",
        StartPosition:"ตำแหน่งเริ่มต้น",
        EndPosition:"ตำแหน่งสิ้นสุด",
        Delimiter:"ตัวคั่น",
        ReferenceKey:"คีย์อ้างอิง",
        RangeValue:"ค่าช่วง",
        DefaultValue: "ค่าเริ่มต้น",
        Mandatory: "จำเป็นต้องกรอกหรือไม่",
        CombineFields: "รวมฟิลด์",
        UploadConfig : "อัปโหลดการกำหนดค่า",
        FileType:"ประเภทไฟล์",
        Delimilter: "ตัวคั่น",
        DelimiterDesc:"ค่าเริ่มต้นคือ “/”, “null” ไม่มีตัวคั่น, “Blank” ช่องว่าง",
        CloneTemplate: "โคลนเทมเพลต",
        TableColumn: "ฟิลด์ตาราง",
        OperationRule: "กฎการทำงาน",
        withHeader: "มีแถวหัวข้อ",
        excelStartRow:"แถวเริ่มต้นข้อมูล",
        isPrintReport:"พิมพ์รายงาน",
        printReportCode:"รหัสรายงานการพิมพ์"
      },

    soPage:{
        PackedFirst:"ไม่อนุญาตให้พิมพ์กรุณาบรรจุก่อน!",
        inputAllQty:"กรุณาใส่จำนวนที่กำหนด!",
        labelCreateDhlShipmentId: "สร้างใหม่ DHL Shipment ID",
        labelAddOrderToShipmentId: "เพิ่มคำสั่งซื้อไปยัง Shipment ID",
        labelShipmentReference: "Shipment Reference",
        labelConfirm: "ยืนยัน",
        labelQuery:"สอบถาม",
        msgShipmentReferenceIsNull: "Shipment Reference ไม่สามารถว่างได้",
    },









    job:{
        Name: "ชื่อ Job",
        Class: "คลาสที่เกี่ยวข้องกับ Job",
        Remark: "หมายเหตุ",
        Type: "ประเภท Job",
        ParamName: "ชื่อพารามิเตอร์",
        ParamValue: "ค่าพารามิเตอร์",
        Seq: "ลำดับ",
        Add: "เพิ่ม",
        Save: "บันทึก",
        Run: "เรียกใช้",
        Delete: "ลบ",
        Reset: "รีเซ็ต",
        Query: "สอบถาม",
        Total: "ทั้งหมด",
        Records: "รายการ",
        notNull: "ต้องไม่เป็นค่าว่าง!",
        Activate: "เปิดใช้งาน",
        Inactivate: "ปิดใช้งาน",
        Action: "การกระทำ",
        Status: "สถานะ",
        Expression: "นิพจน์",
        BusinessType: "ประเภทระบบธุรกิจ",
        StartTime: "เวลาเริ่มต้น",
        ActionNo: "หมายเลขการกระทำ",
        CreateExpression: "สร้างนิพจน์",
        DateTime: "รูปแบบวันที่",
        Year: "ปี",
        Month: "เดือน",
        Day: "วัน",
        Hour: "ชั่วโมง",
        Minute: "นาที",
        Second: "วินาที",
        StatusCanNotDel: "สถานะที่เปิดใช้งานไม่อนุญาตให้ลบ!",
        ExpressionNotCorrect: "นิพจน์ไม่ถูกต้อง!",
        TriggerStatus: "สถานะทริกเกอร์",
        PrevFireTime: "เวลาดำเนินการครั้งก่อน",
        NextFireTime: "เวลาดำเนินการครั้งถัดไป"
    },
    wine: {
        AvailableQty: "จำนวนที่ป้อนเกินปริมาณสินค้าคงคลังที่มีอยู่!",
        inputEnglish: "สามารถป้อนได้เฉพาะภาษาอังกฤษเท่านั้น",
        inputChinese: "สามารถป้อนได้เฉพาะภาษาจีนเท่านั้น",
        maxCharacters: "สูงสุด {0} ตัวอักษร",
        mustInputChinese: "หากไม่ได้กรอกที่อยู่ภาษาอังกฤษ ที่อยู่ภาษาจีนจะต้องกรอก"
    },
    printLabel:{
        NumberOfQrCodeLabelRequired: "จำนวนฉลาก QR Code ที่ต้องการ",
        NumberOfRelIdLabelRequired: "จำนวนฉลาก Rel ID ที่ต้องการ",
        labelType:"ประเภทฉลาก",
        qrCodeLabel:"ฉลากพิมพ์ล่วงหน้า"
    },
    cfs:{
        OrderCancel: "ยกเลิกคำสั่งซื้อ",
        operationSuccess: "ดำเนินการสำเร็จ",
        orderNo: "หมายเลขคำสั่งซื้อ",
        loadingNo: "หมายเลขใบขนสินค้า",
        platformOrderNo: "หมายเลขคำสั่งซื้อแพลตฟอร์ม",
        parcelNo: "บาร์โค้ด",
        unScanQty: "จำนวนที่ยังไม่ได้สแกน",
        invoiceFlag: "พิมพ์ฉลาก / ใบแจ้งหนี้",
        scannedQty: "จำนวนที่สแกนแล้ว",
        parcelNoTrackingNo: "หมายเลขพัสดุ / หมายเลขติดตาม (ฉลากจัดส่งปลายทาง)",
        trackingNo: "หมายเลขติดตาม (ฉลากจัดส่งปลายทาง)",
        destinationCountry: "ประเทศปลายทาง",
        courier: "ผู้จัดส่ง",
        parcelNotOrder: "พัสดุนี้ไม่ได้เป็นของคำสั่งซื้อนี้",
        printLabel: "พิมพ์ฉลาก",
        printDhlInvoice: "พิมพ์ใบแจ้งหนี้การค้า DHL",
        scanLoad: "สแกนการโหลด",
        awbMbl: "AWB / MBL / หมายเลขติดตาม",
        uldNo: "หมายเลขตู้คอนเทนเนอร์ / ULD",
        collectionTimeFrom: "เวลารับสินค้าตั้งแต่",
        collectionTimeTo: "เวลารับสินค้าถึง",
        createLoading: "สร้างใบขนสินค้า",
        confirmLoading: "ยืนยันการโหลด",
        ediSendFlag: "สถานะการส่ง EDI",
        resetFirst: "กรุณารีเซ็ตก่อน",
        noOfDestinationLabelRequired: "จำนวนฉลากปลายทางที่ต้องการ",
        orderNumber: "หมายเลขใบนำส่งสินค้า",
        barcode: "บาร์โค้ด",
        damage: "เสียหาย",
        dimensions: "ขนาด",
        nextOrder: "คำสั่งซื้อถัดไป",
        delete: "ลบ",
        printViewPdf: "พิมพ์ฉลากกล่อง"
    },
    support:{
        org: "องค์กร",
        project: "ชื่อโครงการ",
        a01ReopenASNAsn: "เลขที่ ASN",
        note: "หมายเหตุ",
        submit: "ส่ง",
        reset: "รีเซ็ต",
        c01MovePOToWarehousePO: "เลขที่ PO"
    },
    printerConfig: {
        refresh: "รีเฟรชรายการเครื่องพิมพ์",
        servicesName: "ชื่อเซิร์ฟเวอร์",
        ip: "ที่อยู่ IP",
        printerName: "ชื่อเครื่องพิมพ์",
    },
    scanPack:{
        cancelCheckCompleteMsg: 'ยืนยันที่จะนำกล่องที่บรรจุแล้วทั้งหมดออกหรือไม่?',
        cancelCheckCompleteMoveMsg: 'ต้องการย้ายสินค้าคงคลังที่ยกเลิกทั้งหมดกลับไปยังตำแหน่งเดิมหรือไม่?',
        cancelCheckCompleteNo: 'ไม่',
        cancelCheckCompleteYes: 'ใช่',
        title: 'ยืนยัน',
        currentScanQty: 'จำนวนที่สแกนปัจจุบัน',
        deletePickingData: "ยืนยันที่จะลบข้อมูลการหยิบสินค้าหรือไม่",
        firstCancelCheckCompleteThenScanPack: "คำสั่งซื้อปัจจุบันมีการตรวจสอบบางส่วนเสร็จสมบูรณ์ ต้องการยกเลิกการตรวจสอบที่เสร็จสมบูรณ์หรือไม่",
        antiCounterfeitingCodePleaseConfirm: "รหัสป้องกันการปลอมแปลงไม่ตรงกับรหัสขาออก โปรดยืนยัน",
        currentBrand: "แบรนด์ปัจจุบัน",
        getExpressNumber: "รับหมายเลขพัสดุด่วน",
        ssccAlreadyUse: "SSCC#{0} ไม่อนุญาตให้ผสมคำสั่งซื้อบรรจุภัณฑ์",
        scanByWave: "โปรดสแกนด้วย Wave ID ( {0} )",
        notAllowedBatchClose: "ข้อมูลการบรรจุหีบห่อปัจจุบันยังไม่ได้ส่ง ไม่อนุญาตให้ปิดกล่องจำนวนมาก"
    },
    skuSearch:{
        skuSearch: "ค้นหาสินค้า",
        upcSearch: "ค้นหา UPC",
        sku: "รหัสสินค้า",
        multipleSku: "รหัสสินค้าหลายรายการ",
        skuFrom: "รหัสสินค้าเริ่มต้น",
        skuTo: "รหัสสินค้าสิ้นสุด",
        search: "ค้นหา",
        skuCode: "รหัสสินค้า",
        skuDesc: "รายละเอียดสินค้า",
        upc: "บาร์โค้ดสินค้า",
        style: "สไตล์",
        color: "สี",
        size: "ขนาด"
    },
    invTrans:{
        transType:"ประเภทธุรกรรม",
        transStatus:"สถานะธุรกรรม",
        orderNo:"เลขที่เอกสาร",
        transTimeFrom:"เวลาธุรกรรมจาก",
        transTimeTo:"เวลาธุรกรรมถึง",
        systemUser:"ผู้ใช้ระบบ",
        lotAttribute:"คุณสมบัติล็อต",
        ownerCode:"รหัสเจ้าของสินค้า",
        lotNo:"เลขที่ล็อต",
        id:"หมายเลขติดตาม",
        back:"ย้อนกลับ",
        transId:"รหัสธุรกรรม",
        transTime:"เวลาธุรกรรม",
        lineNo:"เลขที่บรรทัด",
        transactionTime:"การสอบถามบันทึกธุรกรรมต้องอยู่ภายใน {0} วัน!",
        operator:"ผู้ดำเนินการ",
        ownerCodeFrom:"รหัสเจ้าของสินค้าจาก",
        ownerCodeTo:"รหัสเจ้าของสินค้าถึง",
        skuFrom:"สินค้าจาก",
        skuTo:"สินค้าถึง",
        skuDescFrom:"ชื่อสินค้าจาก",
        skuDescTo:"ชื่อสินค้าถึง",
        lotNoFrom:"เลขที่ล็อตจาก",
        lotNoTo:"เลขที่ล็อตถึง",
        idFrom:"หมายเลขติดตามจาก",
        idTo:"หมายเลขติดตามถึง",
        locFrom:"ตำแหน่งจาก",
        locTo:"ตำแหน่งถึง",
        qtyFrom:"จำนวนจาก",
        qtyTo:"จำนวนถึง",
        unitQtyFrom:"จำนวนหน่วยจาก",
        unitQtyTo:"จำนวนหน่วยถึง",
        uomFrom:"หน่วยจาก",
        uomTo:"หน่วยถึง",
        descriptionFrom:"คำอธิบายจาก",
        descriptionTo:"คำอธิบายถึง",
        amount:"จำนวนเงิน",
        typeMustBeSelected:"ต้องเลือกประเภทการดำเนินการ",
        pleaseSelectAQueryPeriod:"โปรดเลือกช่วงเวลาที่ต้องการสอบถาม",
    },
    currency:{
        currency:"สกุลเงิน",
        description:"คำอธิบาย",
        currencySymbol:"สัญลักษณ์สกุลเงิน",
    },
    billingMaintance: {
        add:"เพิ่ม",
        query:"ค้นหา",
        reset:"รีเซ็ต",
        edit:"แก้ไข",
        billId:"เลขที่บิล",
        cutOffFrom:"เวลาตัดยอด",
        billingPeriodFrom:"วันที่เริ่มต้นการเรียกเก็บเงิน",
        billingPeriodTo:"วันที่สิ้นสุดการเรียกเก็บเงิน",
        confirmDate:"วันที่ยืนยัน",
        postDate:"วันที่โพสต์",
        invoiceNo:"เลขที่ใบแจ้งหนี้",
        invoiceDate:"วันที่ใบแจ้งหนี้",
        billToName:"ชื่อผู้รับ",
        billToAddress1:"ที่อยู่ 1",
        billToAddress2:"ที่อยู่ 2",
        billToAddress3:"ที่อยู่ 3",
        billToAddress4:"ที่อยู่ 4",
        billToCity:"เมือง",
        billToProvince:"จังหวัด",
        billToCountry:"ประเทศ",
        billToZip:"รหัสไปรษณีย์",
        billToContactName:"ชื่อผู้ติดต่อ",
        billToContactPhone:"เบอร์โทรศัพท์ติดต่อ",
        billToContactFax:"แฟกซ์",
        billToContactEmail:"อีเมล",
        currency:"สกุลเงิน",
        exchangeRate:"อัตราแลกเปลี่ยน",
        lineNo:"เลขที่บรรทัด",
        chargeMethod:"วิธีการคิดค่าบริการ",
        tariffId:"อัตราภาษี",
        chargeCode:"รหัสค่าใช้จ่าย",
        description:"รายละเอียด",
        billDateFrom:"วันที่เริ่มต้นบิล",
        billDateTo:"วันที่สิ้นสุดบิล",
        billType:"ประเภทบิล",
        billBase:"ฐานบิล",
        billUnit:"หน่วย",
        overflowCharge:"ค่าบริการส่วนเกิน",
        accountCode:"รหัสบัญชี",
        localExchangeRate:"อัตราแลกเปลี่ยนท้องถิ่น",
        baseAmount:"จำนวนเงินพื้นฐาน",
        localAmount:"จำนวนเงินท้องถิ่น",
        totalAmount:"จำนวนเงินรวม",
        invoiceLineSeq:"ลำดับบรรทัดใบแจ้งหนี้",
        CreateMaintance:"สร้าง",
        EditMaintance:"แก้ไข",
        PleaseinputBillId:"โปรดกรอกเลขที่บิล",
        msgBillingPeriodFromLessThanTo:"วันที่เริ่มต้นการเรียกเก็บเงินต้องน้อยกว่าวันที่สิ้นสุดการเรียกเก็บเงิน",

    },
    resPlan:{
        workingDayOnly:"เฉพาะวันทำการ",
        waveIdNotnull:"ห้ามเวฟไอดีเป็นค่าว่าง",
        needCreateResourcePlan:"ต้องการสร้างแผนทรัพยากรหรือไม่?",
    },
    cycleCount:{
        Location: "รหัสตำแหน่งจัดเก็บ",
        createTicket: "สร้างตั๋ว",
        includeStatus: "รวมสถานะ",
        reCount: "นับใหม่",
        numberOfSplit: "จำนวนการแยก",
        confirmToCreateTicketForLocation:"ยืนยันที่จะเริ่มหรือนับตำแหน่งจัดเก็บใหม่ รวมถึงตำแหน่งจัดเก็บที่อยู่นอกบันทึกการนับหรือไม่?",
        confirmToReCountLocation:"ยืนยันที่จะนับตำแหน่งจัดเก็บใหม่หรือไม่?"
    },
    handheldConfiguration:{
        handheldConfiguration:"การตั้งค่าอุปกรณ์พกพา",
        handheldApplicationConfiguration:"การตั้งค่าแอปพลิเคชันอุปกรณ์พกพา",
        configName:'ชื่อการตั้งค่า',
        relatedFunction:'ฟังก์ชันที่เกี่ยวข้อง',
        status:'สถานะ',
        flowSetting:'การตั้งค่าการไหล',
        orderSearch:'ค้นหาคำสั่งซื้อ',
        scanning:'การสแกน',
        haveSearchScreen:'มีหน้าจอค้นหาหรือไม่?',
        scanName:'ชื่อการสแกน',
        promptMessage:'ข้อความแจ้งเตือน',
        actionSettings:'การตั้งค่าการดำเนินการ',
        action:'การดำเนินการ',
        targetField:'ฟิลด์เป้าหมาย',
        field:'ฟิลด์',
        stepSettings:'การตั้งค่าขั้นตอน',
        new: "ใหม่",
        value:'ค่า',
        type:'ประเภท',
        length:'ความยาว',
        dataLength:'ความยาวข้อมูล',
        relatedSettings:'การตั้งค่าที่เกี่ยวข้อง',
        lockValue:'ค้นหาค่าหรือไม่?',
        displayIn:'แสดงใน?',
        showCurrProgress:'แสดงความคืบหน้าปัจจุบัน',
        showSummary:'แสดงสรุป',
        info:'ข้อมูล',
        showConfDialog:'แสดงกล่องโต้ตอบการกำหนดค่า',
        displayText:'ข้อความที่แสดง',
        changeCommand:'เปลี่ยนคำสั่ง',
        last:'(ล่าสุด)',
        completeOnCloseNext:'ปิด/ถัดไป เสร็จสมบูรณ์หรือไม่?',
        suggestLocation:'แนะนำตำแหน่งจัดเก็บหรือไม่?',
        dialogSettings:'การตั้งค่ากล่องโต้ตอบ',
        input:'อินพุต',
        mandatory:'บังคับ',
        dimension:'มิติ',
        volume:'ปริมาตร',
        grossWeight:'น้ำหนักรวม',
        netWeight:'น้ำหนักสุทธิ',
        logicSettings:'การตั้งค่าตรรกะ',
        use:'ใช้',
        priority:'ลำดับความสำคัญ',
        lastLocation:'ตำแหน่งจัดเก็บล่าสุด',
        nextEmptyLocation:'ตำแหน่งจัดเก็บว่างถัดไป',
        pickLocation:'ตำแหน่งจัดเก็บสำหรับหยิบ',
        storageLocation:'ตำแหน่งจัดเก็บสำหรับจัดเก็บ',
        closeToSameSku:'ปิด SKU เดียวกัน',
        matchItemType:'จับคู่ประเภทสินค้าเดียวกัน',
        useProjectLocation:'ใช้ตำแหน่งจัดเก็บโครงการ',
        useWarehouseLocation:'ใช้ตำแหน่งจัดเก็บคลังสินค้า',
        scanSingle:'สแกนรายการเดียวหรือไม่?',
        displayInformation:'แสดงข้อมูล',
        scanningScanNameCannotBeEmpty:'ชื่อการสแกน {0} ต้องไม่ว่างเปล่า',
        orderSearchScanNameCannotBeEmpty:'ชื่อการสแกนการค้นหาคำสั่งซื้อต้องไม่ว่างเปล่า',
    },
    cycleCountMaster:{
        belowLocationAndSku:"ตำแหน่งจัดเก็บและ SKU ด้านล่างมีปริมาณที่จัดสรร/ปริมาณที่ถืออยู่ คุณแน่ใจหรือไม่ที่จะละเว้นสิ่งเหล่านี้เพื่อสร้างคำสั่งนับ?",
        quantityNeedsToBeGreaterThan0:"ปริมาณต้องมากกว่า 0",
        createCountOrderByNumber:"สร้างใบสั่งนับตามจำนวนการนับเริ่มต้นหรือไม่?",
        countOrderCompleteOrder:"การนับสินค้าคงคลัง {0} และตั๋วที่เกี่ยวข้องยังอยู่ระหว่างดำเนินการ\n" +
            "คุณต้องการปิดธุรกรรมที่ยังไม่ปิดและดำเนินการนับสินค้าคงคลังให้เสร็จสิ้นหรือไม่?",
    },
    confirmDeleteLoading:"คำสั่งซื้อถูกโหลดแล้ว คุณยืนยันที่จะลบออกจากรายการโหลดหรือไม่?",
    expDeliveryDateNotnull:"วันที่จัดส่งที่คาดการณ์ไว้ต้องไม่ว่างเปล่า!",
    scanIn:"สแกนรับสินค้า",
    carrier:"ผู้ขนส่ง",
    flightNo:"หมายเลขเที่ยวบิน",
    parcelUnWeighed:"พัสดุยังไม่ได้ชั่งน้ำหนัก",
    airLine:"สายการบิน",
    arrivedTime:"เวลาที่มาถึง",
    shipFrom:"ต้นทาง",
    shipTime:"เวลาออกเดินทาง",
    services:"บริการ",
    servicesProvider:"ผู้ให้บริการ",
    gatewayCannotBeEmpty:"เกตเวย์ต้องไม่ว่างเปล่า",
    serviceCannotBeEmpty:"บริการต้องไม่ว่างเปล่า",
    serviceProviderCannotBeEmpty:"ผู้ให้บริการต้องไม่ว่างเปล่า",
    skynetPostal:"ช่องทางไปรษณีย์",
    battery:"แบตเตอรี่",
    batteryCannotBeEmpty:"แบตเตอรี่ต้องไม่ว่างเปล0่า",
    copyLoading:"คัดลอกรายการโหลด",
    showAll:"แสดงทั้งหมด",
    processActionMsg:"ยืนยันการดำเนินการนี้หรือไม่?",
    orderRef: "หมายเลขคำสั่งซื้อ",
    printNotConnected: "เครื่องพิมพ์เชื่อมต่อล้มเหลว",
    notLabelRecord:"ไม่พบระเบียน",
    collarBarcode:{
        woolenCollarBarcode:"บาร์โค้ดคอขนสัตว์",
        woolenCollarBarcodeMismatch:"บาร์โค้ดคอขนสัตว์ไม่ตรงกัน",
        missing:"ขาดหายไป",
    },
    soStatus:{
        partialAllocated:"จัดสรรบางส่วน",
        allocation:"การจัดสรร",
        partialPicked:"หยิบบางส่วน",
        picked:"หยิบครบถ้วน",
        partialPacked:"บรรจุบางส่วน",
        packed:"บรรจุครบถ้วน",
        partialLoaded:"โหลดบางส่วน",
        loaded:"โหลดครบถ้วน",
        partialShipped:"จัดส่งบางส่วน",
        shipped:"จัดส่งครบถ้วน",
        delivered:"จัดส่งแล้ว",
        billed:"ออกบิลแล้ว",
        cancelled:"ยกเลิกคำสั่งซื้อ",
        deleted:"ลบแล้ว",
        closed:"คำสั่งซื้อเสร็จสมบูรณ์",
    },
    asnStatus:{
        partialReceived:"รับสินค้าบางส่วน",
        received:"รับสินค้าครบถ้วน",
        partialPutaway:"จัดเก็บบางส่วน",
        putaway:"จัดเก็บครบถ้วน",
        cancelled:"สถานะยกเลิก",
        deleted:"สถานะถูกลบ",
        closed:"สถานะปิด",
    },
    loading:{
        loadId:"รหัสการโหลด",
        container:"หมายเลขการโหลด",
        hidden: "ซ่อน",
        searchCartonByWave:"ค้นหากล่องตาม Wave",
        importSscc:"นำเข้า SSCC",
        seal:"หมายเลขซีล",
        containerType:"ประเภทการโหลด",
        vesselFight:"เรือ",
        voyage:"เส้นทางเดินเรือ",
        mbl:"MBL",
        hbl:"HBL",
        driver:"คนขับ",
        etd:"เวลาออกเดินทางโดยประมาณ",
        eta:"เวลามาถึงโดยประมาณ",
        portOfLoading:"ท่าเรือต้นทาง",
        portOfDischarge:"ท่าเรือปลายทาง",
        portOfDestination:"ท่าเรือปลายทาง",
        loadFrom:"เวลาเริ่มต้นการโหลด",
        loadTo:"เวลาสิ้นสุดการโหลด",
        remarks:"หมายเหตุ",
        loadedCartonQty:"จำนวนกล่องที่โหลด",
        detailSearch:"ค้นหารายละเอียด",
    },
    filterBy:"กรองโดย",
    allocationResults: "ผลการจัดสรร",
    importResults:"ผลการนำเข้า",
    lastestNotifications:"การแจ้งเตือนล่าสุด {0} รายการ",
    todayNotifications:"การแจ้งเตือนวันนี้",
    yesterdayNotifications:"การแจ้งเตือนเมื่อวานนี้",
    success:"สำเร็จ",
    failed:"ล้มเหลว",
    inputNumCharsThenPressEnter:"โปรดป้อนอักขระ {0} ตัวขึ้นไปแล้วกด <enter>",
    queryCondition:"เงื่อนไขการค้นหา",
    thaiName:"ชื่อภาษาไทย",
    japaneseName:"ชื่อภาษาญี่ปุ่น",
    headerJoinFieldName:"ชื่อฟิลด์เชื่อมโยงหลัก",
    detailJoinFieldName:"ชื่อฟิลด์เชื่อมโยงรายละเอียด",
    queryFieldName:"ชื่อฟิลด์การค้นหา",
    compareType:"ประเภทการเปรียบเทียบ",
    fixedValue:"ค่าคงที่",
    pageType:"ประเภทการควบคุม",
    codeMasterGroup:"กลุ่มดัชนีข้อมูลหลัก",
    queryTable:"ตารางที่ฟิลด์อยู่",
    headerTable:"ตารางเชื่อมโยงหลัก",
    detailTable:"ตารางเชื่อมโยงรายละเอียด",
    stdBalanceReport: {
        brand: "ยี่ห้อ",
        size: "ขนาด",
        volume: "ปริมาตรต่อชิ้น",
        totalVolume: "ปริมาตรรวม",
        department: "แผนก",
        sku: "สินค้า",
        skuName: "ชื่อสินค้า",
        material: "รหัสวัสดุ/รหัสสินค้า",
        specification: "ข้อมูลจำเพาะ",
        units: "หน่วย",
        qty: "จำนวน",
        inboundTime: "เวลาเข้าล่าสุด",
        outboundTime: "เวลาออกล่าสุด",
        period: "ช่วงเวลา",
        remark: "หมายเหตุ/คำอธิบาย",
        Location: "ตำแหน่งคลังสินค้า",
        prePicture: "ดูภาพตัวอย่าง",
    },

    // โมดอลเข้าสู่ระบบหลายภาษา
    sessionModal: {
        title: "การเข้าสู่ระบบหมดอายุแล้ว",
        message: "เนื่องจากไม่มีการใช้งานเป็นเวลานาน กรุณาเข้าสู่ระบบใหม่",
        passwordChangedMessage: "รหัสผ่านถูกเปลี่ยนแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
        username: "ชื่อผู้ใช้",
        password: "รหัสผ่าน",
        loginButton: "เข้าสู่ระบบ",
        logoutButton: "ออกจากระบบ",
        usernameRequired: "กรุณากรอกชื่อผู้ใช้และรหัสผ่าน",
        passwordRequired: "กรุณากรอกรหัสผ่าน",
        loginFailed: "เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่าน",
        loginError: "เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        loginSuccess: "เข้าสู่ระบบใหม่สำเร็จ",
        loginLoading: "กำลังเข้าสู่ระบบ...",
        loginTimeout: "หมดเวลาการร้องขอ กรุณาลองใหม่อีกครั้ง",
        securityTitle: "คำเตือนด้านความปลอดภัย",
        securityMessage: "ตรวจพบการแก้ไขข้อมูลที่ไม่ได้รับอนุญาต กรุณาเข้าสู่ระบบใหม่เพื่อความปลอดภัย",
        securityWarning: "เพื่อความปลอดภัยของคุณ กรุณายืนยันตัวตนของคุณ",
        tokenExpiredMessage: "เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง",
        tokenInvalidMessage: "โทเค็นการยืนยันตัวตนไม่ถูกต้อง กรุณาเข้าสู่ระบบอีกครั้ง",
        noPermissionTitle: "ไม่มีสิทธิ์",
        noPermissionMessage: "คุณไม่มีสิทธิ์ในการเข้าถึงทรัพยากรนี้",
        okButton: "ตกลง",
        projectChangedTitle: "โปรเจกต์มีการเปลี่ยนแปลง",
        projectChangedMessage: "โปรเจกต์ปัจจุบันมีการเปลี่ยนแปลง กรุณารีเฟรชหน้าเพื่อโหลดข้อมูลโปรเจกต์ที่ถูกต้อง",
        reloadButton: "รีเฟรชหน้า",
        reloginButton: "เข้าสู่ระบบอีกครั้ง"
    },
    projectQueryList:"รายการค้นหาโครงการ",
    defaultQueryList:"รายการค้นหาเริ่มต้น",
    hide:"ซ่อน",
    show:"แสดง",
    copyToProjectList:"คัดลอกไปยังรายการโครงการ",
    copyToAnotherLanguage:"คัดลอกไปยังภาษาอื่น",
    copyToAnotherProject:"คัดลอกไปยังโครงการอื่น",
    copyTo:"คัดลอกไปยัง",
    DueDateUpdateConfirm:"ด้านล่าง Wave มีวันครบกำหนด Scan Pack อยู่แล้ว ยืนยันที่จะอัปเดต?",
    domain:"โดเมน",
    singleSignOn:"การลงชื่อเข้าใช้ครั้งเดียว",
}